import { closeModal, openModal } from '@components/modals';
import { execOnLoad } from '@general/helpers';
import './mobile-menu.scss';
import breakpoints from 'breakpoints';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initMobileMenu = (context) => {
  const snippetContainer = context.classList.contains('mobile-menu__container')
    ? context
    : context.closest('.mobile-menu__container');
  if (!snippetContainer) return;
  const header = document.querySelector('.header__background');
  const menuButton = snippetContainer.querySelector('.mobile-menu__icon');
  const closerButton = snippetContainer.querySelector('.mobile-menu__closer');
  const modal = snippetContainer.querySelector('.modal');
  const enableTransparency = header.hasAttribute('data-transparent');
  if (!menuButton || !modal) return;

  menuButton.addEventListener('click', () => {
    if (modal.classList.contains('open')) {
      snippetContainer.classList.remove('open');
      closeModal(modal);
      if (enableTransparency) header.dataset.transparent = 'true';
      snippetContainer
        .querySelectorAll('.mobile-menu__second-level.open')
        .forEach((secondLevel) => secondLevel.classList.remove('open'));
    } else {
      const announcementHeight = parseInt(
        getComputedStyle(document.documentElement).getPropertyValue('--announcement-bar-height'),
      );
      if (window.scrollY < announcementHeight) window.scrollTo({ top: announcementHeight, behavior: 'smooth' });

      snippetContainer.classList.add('open');
      openModal(modal);
      if (enableTransparency) header.dataset.transparent = 'false';
    }
  });

  closerButton.addEventListener('click', () => {
    if (modal.classList.contains('open')) {
      snippetContainer.classList.remove('open');
      closeModal(modal);
      if (enableTransparency) header.dataset.transparent = 'true';
      snippetContainer
        .querySelectorAll('.mobile-menu__second-level.open')
        .forEach((secondLevel) => secondLevel.classList.remove('open'));
    }
  });

  const lgUp = window.matchMedia(`(min-width: ${breakpoints.lg})`);
  const handleNavigation = () => {
    if (lgUp.matches && snippetContainer.classList.contains('open')) {
      snippetContainer.classList.remove('open');
      closeModal(modal);
      if (enableTransparency) header.dataset.transparent = 'true';
      snippetContainer
        .querySelectorAll('.mobile-menu__second-level.open')
        .forEach((secondLevel) => secondLevel.classList.remove('open'));
    }
  };
  lgUp.addEventListener('change', handleNavigation);
  const firstLevelTabsContainer = snippetContainer.querySelector('.mobile-menu__tabs');
  const firstLevelTabs = firstLevelTabsContainer?.querySelectorAll('.mobile-menu__first-level-tab');
  if (firstLevelTabs) {
    snippetContainer.querySelectorAll('.mobile-menu__first-level--openable').forEach((firstLevel) => {
      const firstLevelId = firstLevel.dataset.menuId;
      const firstLevelTab = firstLevelTabsContainer.querySelector(
        `.mobile-menu__first-level-tab[data-menu-id='${firstLevelId}']`,
      );
      if (!firstLevelTab) return;
      firstLevel.addEventListener('click', () => {
        firstLevelTabs.forEach((tab) => tab.classList.remove('open'));
        snippetContainer
          .querySelectorAll('.mobile-menu__first-level--openable')
          .forEach((opener) => opener.classList.remove('open'));
        firstLevel.classList.add('open');
        firstLevelTab.classList.add('open');
      });
    });
  }

  snippetContainer.querySelectorAll('.mobile-menu__second-level').forEach((secondLevel) => {
    const close = secondLevel.querySelector('.mobile-menu__back');
    if (!close) return;
    close.addEventListener('click', () => secondLevel.classList.remove('open'));
  });
};

execOnLoad(window.dAgency.initMobileMenu, '.mobile-menu__container');
